import Call from "../../service/axios";
import {getUrl} from "../../constants/urls";
import {trackPromise} from "react-promise-tracker";

export const getDashboardData = () => {
  const simUrl = getUrl("homepageData");
  return trackPromise(Call.get(simUrl));
};
